
import { defineComponent, ref, onMounted } from "vue";
// import Dropdown1 from "@/components/dropdown/Dropdown1.vue";
import { toolbarWidthFluid } from "@/core/helpers/config";
import emitter from "@/eventBus";

export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  // components: {
  //   Dropdown1,
  // },
  setup() {
    const customContent = ref<any>(null); // Can be Component or VNode

    onMounted(() => {
      emitter.on("set-toolbar-content", (content) => {
        console.log("Setting custom toolbar content:", content);
        customContent.value = content;
      });
    });

    return {
      toolbarWidthFluid,
      customContent
    };
  },
});
